export const sampleModel: IModel = {
  id: 'f5f4',
  source: 'generators',
  thumbnailUrl: '',
  generatorName: '',
  modifiedAt: '2025-02-17T16:20:19.443Z',
  generatorId: 'G-181',
  paletteId: '50e6869e-211b-49dd-b9a2-874e8c30e4bb',
  valuesModel: {
    'base.body': 'Fin',
    'base.front': 'SpeederRound',
    'base.wing': 'BasicEngine',
    'base.gun': 'SciFiGun',
    'base.tail': 'JetTail',
    'dimensions.height': 0.5,
    'dimensions.width': 0.5,
    'dimensions.length': 0.2,
    'dimensions.thickness': 0.5,
    'dimensions.vents': true,
    'dimensions.lowPolyVents': false,
    'engines.engineCorner': 1,
    'engines.engineRotate': 0.5,
    'engines.frontEngineLength': 0.5,
    'engines.frontEngineHeight': 0.5,
    'engines.frontEngineWidth': 0.5,
    'engines.backEngineLength': 0.5,
    'engines.backEngineHeight': 0.5,
    'engines.backEngineWidth': 0.5,
    'container.rotateHatch': 0.5,
    'wings.wingLength': 0.5,
    'wings.wingDepth': 0.5,
    'wings.wingThickness': 0.5,
    'wings.wingGunLength': 0.5,
    'wings.wingGuns': true,
    'front.frontLength': 0.7,
    'front.frontHeight': 0.5,
    'front.frontGuns': true,
    'tail.tailFinLength': 0.5,
    'tail.tailLength': 0.75,
    'tail.tailSize': 0.5,
    LOD: 0.5,
  },
  materials: {
    '0': {
      id: '0',
      tint: '#E9E9E9',
      metalness: 0.3,
      roughness: 0.3,
      specular: 0.5,
      emission: 0,
      transparency: 1,
    },
    '1': {
      id: '2',
      tint: '#FFFBFB',
      metalness: 0.9,
      roughness: 0.5,
      specular: 0.5,
      emission: 0,
      transparency: 1,
    },
    '2': {
      id: '2',
      tint: '#F2843E',
      metalness: 0.4,
      roughness: 0.4,
      specular: 0.5,
      emission: 0,
      transparency: 1,
    },
    '3': {
      id: '3',
      tint: '#2E2E2E',
      metalness: 0.5,
      roughness: 0.3,
      specular: 0.5,
      emission: 0,
      transparency: 1,
    },
  },
  name: 'Sci-fi Planes',
};
